// extracted by mini-css-extract-plugin
export default {"addToCartControl":"xY-z","giftCard":"yY-z","btnContainer":"zY-z","cartButton":"AY-z","disabled":"BY-z","stockMessage":"CY-z"};